/** @jsx jsx */

import { Dropdown, LegacyIconButton, Spacer } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { ORDER_ITEMS, IssueOrderBy, IssueOrderDirection } from '../constants';

const Styles = {
  root: css`
    display: flex;
    align-items: flex-end;
  `,
  orderWrapper: css`
    display: flex;
    flex-direction: column;
    width: 130px;

    & > span {
      margin-bottom: 8px;
      font-weight: 600;
    }
  `,
};

type Props = {
  onChangeOrderBy: (orderBy: IssueOrderBy) => void;
  onChangeOrderDirection: (orderDireciton: IssueOrderDirection) => void;
  orderBy: IssueOrderBy;
  orderDirection: IssueOrderDirection;
};

function IssueOrder({
  onChangeOrderBy,
  onChangeOrderDirection,
  orderBy,
  orderDirection,
}: Props) {
  const isAscending = orderDirection === IssueOrderDirection.ASC;

  return (
    <div css={Styles.root}>
      <div css={Styles.orderWrapper}>
        <span>Sort by</span>
        <Dropdown
          aria-label="Issue ordered by"
          getLabelForItem={item => item.label}
          items={ORDER_ITEMS}
          menuAriaLabel="List of issue orders"
          onChange={item => onChangeOrderBy(item.value)}
          placeholder="Choose a order…"
          selectedItem={ORDER_ITEMS.find(item => item.value === orderBy)}
        />
      </div>
      <Spacer width="10px" />
      <LegacyIconButton
        color="icon-primary"
        icon={isAscending ? 'arrowSmallUp' : 'arrowSmallDown'}
        label={isAscending ? 'Ascending' : 'Descending'}
        onClick={() =>
          onChangeOrderDirection(
            isAscending ? IssueOrderDirection.DESC : IssueOrderDirection.ASC
          )
        }
        tooltipPosition="southeast"
      />
    </div>
  );
}

export default IssueOrder;
